<template>
  <div class="view-container">
    <div class="tabs-wrapper">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="14">
          <a-form-model
            layout="horizontal"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="关键字">
                  <a-input-search
                    placeholder="请输入关键字"
                    @search="onSearch"
                    @change="onSearch"
                    size="default"
                    v-model="keyword"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="时间范围">
                  <a-range-picker v-model="timeRange" @change="onSearch" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-col>
        <a-col :span="10">
          <div class="toolbtn" style="float: right;">
            <a-space>
              <a-popconfirm
                title="确定要删除吗 ?"
                @confirm="() => onDeleteInBatch()"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  style="color: red"
                />
                <a-button type="default"
                  ><a-icon type="delete" />删除选中</a-button
                >
              </a-popconfirm>
              <a-button :loading="exporting" type="primary" @click="onExport"
                >导出</a-button
              >
            </a-space>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :rowSelection="rowSelection"
          :pagination="pagination"
          :scroll="{ x: 15 }"
          size="small"
          @change="paginationChange"
        >
          <template slot="cell" slot-scope="text">
            <a-tooltip trigger="hover">
              <template slot="title">
                <span v-html="text"> </span>
              </template>
              <span
                v-html="formatContent(text, keyword)"
                class="cell2-text"
              ></span>
            </a-tooltip>
          </template>
          <template slot="sent" slot-scope="text">
            <a-tag v-if="text" color="green">
              已发送
            </a-tag>
            <a-tag v-else color="gray">
              未发送
            </a-tag>
          </template>

          <template slot="operation" slot-scope="text, record">
            <a-popconfirm
              v-if="tableData.length"
              title="确定删除吗 ?"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:;"> <a-icon type="delete" /> 删除 </a>
            </a-popconfirm>
            <a
              @click="sendMail(record)"
              href="javascript:;"
              style="margin-left: 10px;"
            >
              <a-icon type="mail" /> 发送产品邮件
            </a>
          </template>
        </a-table>
      </a-row>
    </div>
  </div>
</template>

<script>
import {
  getTrial,
  deleteTrial,
  // eslint-disable-next-line
  sendProduct,
  rpaAuth,
  exportExcel
} from '@/api/product-trial'

import * as RPA from './rpa.params'
import moment from 'moment'
export default {
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      columns: [],
      tableData: [],
      rowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.rowKeys = selectedRowKeys
        }
      },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: '',
      time1: null,
      time2: null,
      timeRange: null,
      exporting: false
    }
  },
  created() {
    this.columns = [
      {
        title: '姓名',
        dataIndex: 'name',
        width: 100,
        fixed: 'left',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '手机区号',
        dataIndex: 'phone_prefix',
        width: 90,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '手机号',
        dataIndex: 'phone',
        width: 150,
        scopedSlots: { customRender: 'cell' }
      },

      {
        title: '所在企业',
        dataIndex: 'enterprise',
        width: 250,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '产品',
        dataIndex: 'product',
        width: 250,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '需求',
        dataIndex: 'needing',
        width: 250,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '身份证号',
        dataIndex: 'idNumber',
        width: 180,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '备注',
        dataIndex: 'remark',
        width: 200,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '企业邮箱',
        dataIndex: 'email',
        width: 150,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '所在行业',
        dataIndex: 'business',
        width: 250,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        width: 150,
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        },
        fixed: 'right'
      },
      {
        title: '已发送邮件',
        dataIndex: 'sent',
        width: 110,
        fixed: 'right',
        scopedSlots: { customRender: 'sent' }
      },
      {
        width: 200,
        // width: 100,
        title: '操作',
        fixed: 'right',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination, timeRange } = this
      const range = {}
      if (timeRange && timeRange.length > 0) {
        range.createdAt1 = timeRange[0].format('YYYY-MM-DD')
        range.createdAt2 = timeRange[1].format('YYYY-MM-DD') + ' 23:59:59'
      }
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      getTrial({ keyword, page, size, ...range }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    onDelete(id) {
      const ids = [id].join(',')
      this.delete(ids)
    },
    delete(ids = '') {
      deleteTrial({ ids }).then(() => {
        this.fetchData()
        this.$notification['success']({
          message: '成功',
          description: '删除成功',
          duration: 3
        })
      })
    },

    onDeleteInBatch() {
      const { rowKeys } = this
      if (rowKeys && rowKeys.length > 0) {
        const ids = rowKeys.join(',')
        this.delete(ids)
        this.fetchData()
      }
    },

    async sendMail(item) {
      let res = await sendProduct({
        id: item.id,
        receiver: item.email,
        name: item.name
      })
      if (res.code === 200) {
        this.$notification['success']({
          message: '成功',
          description: '邮件发送成功'
        })
        this.fetchData()
        let r = await this.rpaProductAuth(item)
        if (r) {
          this.$notification['success']({
            message: '成功',
            description: `产品账号${item.phone}申请成功`
          })
        }
      } else {
        this.$notification['error']({
          message: '错误',
          description: '邮件发送失败'
        })
      }
    },

    async rpaProductAuth(user) {
      const tokenParams = RPA.getTokenParams()
      let res3
      try {
        // 获取token
        const res = await rpaAuth(tokenParams)
        const token = (res.find(it => it.Name === 'Token') || {}).Value
        // 新增用户
        const { phone, name, email, enterprise } = user
        const userParams = RPA.getUserParams(
          token,
          phone,
          name,
          email,
          enterprise
        )
        const res2 = await rpaAuth(userParams)
        const loginId = (res2.find(it => it.Name === 'ID') || {}).Value
        // 用户授权
        const roleParams = RPA.getRoleParams(token, loginId)
        res3 = await rpaAuth(roleParams)
      } catch (error) {
        this.$notification['error']({
          message: '失败',
          description: `产品账号申请失败`
        })
      }
      return res3
    },

    formatContent(text, keyword) {
      text = text || ''
      if (typeof text !== 'string') {
        text = String(text)
      }
      return text.replace(
        new RegExp(keyword, 'g'),
        `<strong style="color: red;">${keyword}</strong>`
      )
    },
    onExport() {
      let { keyword, timeRange } = this
      const range = {}
      if (timeRange && timeRange.length > 0) {
        range.createdAt1 = timeRange[0].format('YYYY-MM-DD')
        range.createdAt2 = timeRange[1].format('YYYY-MM-DD') + ' 23:59:59'
      }
      keyword = keyword.trim()

      this.exporting = true
      exportExcel({
        keyword,
        ...range
      }).finally(() => {
        this.exporting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cell2-text {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.label {
  margin-left: 20px;
}
</style>
